import { createStyles } from "@mantine/core";

const UseStyles = createStyles((theme) => ({
  root: {
    paddingTop: 20,
    paddingBottom: 20,
  },

  label: {
    textAlign: "center",
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    marginBottom: theme.spacing.xl * 1.5,
    color: theme.colors.gray[2],

    [theme.fn.smallerThan("sm")]: {
      fontSize: 120,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: "center",
    fontWeight: 900,
    fontSize: 38,

    [theme.fn.smallerThan("sm")]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: "auto",
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.xl * 1.5,
  },

  button: {
    backgroundColor: "#001951",

    "&:hover": {
      backgroundColor: theme.fn.lighten("#001951", 0.15),
    },
  },
}));

export default UseStyles;
